
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52.917 68.792","height":"260","width":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#f5f5f5","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.26 8.804h40.396v51.183H6.26z"}}),_c('path',{attrs:{"d":"M18.36 41.893l-7.501-7.502 7.502-7.502v15.004zM34.56 26.889l7.503 7.502-7.502 7.502V26.89z","fill":"#f5f5f5"}})])
          )
        }
      }
    